export { default as Root } from './Tag';
export type { TagProps } from './Tag';

export { default as Label } from './Label';
export type { TagLabelProps } from './Label';

export { default as Dismiss } from './Dismiss';
export type { TagDismissProps } from './Dismiss';
